import { BRAND_SECONDARY } from "../../../utils/Styles";
import {
  Calendar,
  Callout,
  DayOfWeek,
  DefaultButton,
  DetailsListLayoutMode,
  DirectionalHint,
  Dropdown,
  Fabric,
  FocusTrapZone,
  IColumn,
  IDropdownOption,
  PrimaryButton,
  SelectionMode,
  ShimmeredDetailsList,
  Stack,
  Text,
  TextField,
  Toggle,
  TooltipHost,
} from "office-ui-fabric-react";
import React from "react";
import { useParams } from "react-router-dom";
import {
  ICustomerConfig,
  IDataCenter,
  ITempRhReadings,
} from "../../../vm";
import moment from "moment";
import {
  addOrUpdateCustomerConfig,
  getCustomerConfig,
  getDatacentersForACustomer,
  updateTempAndHumidity,
} from "../../../services/customers/CustomerService";
import {
  API_URL,
  childrenGap,
  childrenGap8,
  DayPickerStrings,
} from "../../common/Constants";
import { ToastContext } from "../../common/ToastProvider";
import Icon from "@mdi/react";
import {
  mdiArrowDown,
  mdiArrowUp,
  mdiCheckCircleOutline,
  mdiCloseCircleOutline,
  mdiDotsVertical,
} from "@mdi/js";
import { getToken, parseJwt, toFixedValue } from "../../../services/UtilService";
import ManageTempAndRhDialog from "../../infrastructure-automation/temp-rh/ManageTempAndRhDialog";
// import { getSLAMatrixConfig } from "../../../services/sla-matrix/SlaMatrixService";
import { Loading } from "../../../services/Loading";
import { getMorTempAndRhReadings } from "../../../services/infrastructure-automation/InfrastructureAutmationService";
import NoDataTile from "../../common/NoDataTile";

export interface AmbientTempRhMainProps {
  customerName: string;
}

let calendarButtonElement: HTMLElement;

const AmbientTempRhMain: React.FC<AmbientTempRhMainProps> = ({
  customerName,
}) => {
  //hooks
  const params: any = useParams();
  const { showToast } = React.useContext(ToastContext);
  const tokenData = parseJwt();

  const queryParams = new URLSearchParams(window.location.search);

  //state
  const [state, setState] = React.useState({
    isLoading: false,
    date: queryParams.get("date")
      ? new Date(queryParams.get("date") as string)
      : new Date(),
    showCallender: false,
    searchObj: {
      startDate: queryParams.get("date")
        ? new Date(queryParams.get("date") as string)
        : new Date(),
      endDate: queryParams.get("date")
        ? new Date(queryParams.get("date") as string)
        : new Date(),
      datacenterId: "",
      isAmbient: true,
      isForCustomer: true
    },
    tempHumidity: [],
    manageTempRhDialog: {
      isOpen: false,
      index: undefined,
      data: undefined,
    },
    slaMatrix: {},
    tempRhObj: {
      date: new Date(),
      temp: 0,
      rh: 0,
      sensorId: ""
    },
    manageActionsCallout: {
      isOpen: false,
      index: undefined,
      element: undefined,
      data: undefined,
    },
    isOnEdit: false,
    datacenters: [],
    datacenterDropdown: [],
    powerReportConfig: [],
    managePageDialog: {
      isOpen: false,
      tempRhPageId: ""
    },
    manageRemarksDialog: {
      isOpen: false,
      tempRhPageId: "",
      pageName: ""
    },
    manageHeaderActionsCallout: {
      isOpen: false,
      index: undefined,
      element: undefined,
      data: undefined,
    },
    customerConfig: {
      customerId: params.customerId,
      showAmbientSensors: false,
    }
  } as {
    isLoading: boolean;
    date: Date;
    showCallender: boolean;
    searchObj: {
      datacenterId: string;
      isAmbient: boolean;
      startDate: Date | string;
      endDate: Date | string;
      isForCustomer: boolean;
    };
    tempHumidity: any[];
    manageTempRhDialog: {
      isOpen: boolean;
      index?: number;
      data?: any;
    };
    slaMatrix: any;
    tempRhObj: ITempRhReadings;
    manageActionsCallout: {
      isOpen: boolean;
      element: any;
      index?: number;
      data?: any;
    };
    isOnEdit: boolean;
    datacenters: IDataCenter[];
    datacenterDropdown: IDropdownOption[];
    customerConfig: ICustomerConfig
  });

  React.useEffect(() => {
    const asyncFunc = () => {
      getAllDatacenter();
    };
    asyncFunc();
  }, []);

  const getAllDatacenter = async () => {
    setState({ ...state, isLoading: true });
    let result = await getDatacentersForACustomer({
      customerId: params.customerId,
    });
    if (result?.success) {
      let datacenterDropdown: IDropdownOption[] = [];

      result.data?.forEach((item) => {
        datacenterDropdown.push({
          key: item._id as string,
          text: item.name,
        });
      });

      let obj = {
        ...state,
        datacenters: result.data,
        datacenterDropdown,
        searchObj: {
          ...state.searchObj,
          datacenterId: result.data[0]?._id,
        },
      };
      setState(obj);
      // getSlaMatrix(obj);
      getCustomerConfigurations(obj);
    } else {
      setState({ ...state, isLoading: false });
      showToast(result.message || "Error while getting datacenters", "error");
    }
  };

  // const getSlaMatrix = async (paramState?: any) => {
  //   let localState = { ...state };
  //   if (paramState) {
  //     localState = { ...paramState };
  //   }
  //   setState({ ...localState, isLoading: true });
  //   let result = await getSLAMatrixConfig(params.customerId);
  //   if (result?.success) {
  //     let obj = {
  //       ...localState,
  //       slaMatrix: result.data || { humidity: {}, temperature: {} },
  //       isLoading: false,
  //     };
  //     setState(obj);
  //     getTempHumidity(obj);
  //   } else {
  //     setState({ ...state, isLoading: false });
  //     showToast(result?.message || "Error while getting sla matrixes", "error");
  //   }
  // };

  const getCustomerConfigurations = async (paramState: any) => {
    let localState = { ...state };
    if (paramState) {
      localState = { ...localState, ...paramState };
    }
    setState({ ...localState, isLoading: true });
    let result = await getCustomerConfig({ customerId: params.customerId });
    if (result && result.success) {
      const obj = {
        ...localState,
        customerConfig: result.data.length > 0 ? result.data[0] : { ...localState.customerConfig },
        isLoading: false,
      };
      setState(obj);
      getTempHumidity(obj);
    } else {
      setState({ ...state, isLoading: false });
      showToast(
        result.message || "Error while getting customer config",
        "error"
      );
    }
  }

  const getTempHumidity = async (paramState?: any) => {
    let localState = { ...state };

    if (paramState != null) {
      localState = { ...localState, ...paramState };
    }
    setState({ ...localState, isLoading: true });

    let tempSearch = { ...localState.searchObj };

    tempSearch.startDate = moment(tempSearch.startDate)
      .startOf("month")
      .format("YYYY-MM-DD");
    tempSearch.endDate = moment(tempSearch.endDate)
      .endOf("month")
      .format("YYYY-MM-DD");

    let result = await getMorTempAndRhReadings(tempSearch);
    if (result?.success) {
      let obj = {
        ...localState,
        tempHumidity: result.data,
        isLoading: false,
      };
      setState(obj);
    } else {
      setState({ ...state, isLoading: false });
      showToast(
        result.message || "Error while getting Temperature & Humidity",
        "error"
      );
    }
  };

  const handleCallOutOpenClose = (
    isOpen: boolean,
    ele?: React.MouseEvent<HTMLSpanElement>,
    index?: number,
    data?: any
  ) => {
    setState({
      ...state,
      isOnEdit: false,
      manageActionsCallout: {
        isOpen,
        element: isOpen ? ele?.currentTarget : undefined,
        index,
        data,
      },
    });
  };

  const _renderItemColumn = (item: any, index: number, column: IColumn) => {
    switch (column.key) {
      case "actions":
        return (
          <>
            {state.isOnEdit && state.manageActionsCallout.index === index ? (
              <Stack horizontal tokens={childrenGap}>
                <React.Fragment>
                  <TooltipHost
                    content={`Save`}
                    id={`saveTempRh`}
                    calloutProps={{ gapSpace: 0 }}
                    styles={{ root: { display: "inline-block" } }}
                  >
                    <span onClick={onUpdateTempRh}>
                      <Icon
                        path={mdiCheckCircleOutline}
                        size={0.8}
                        className="pointer"
                        color="green"
                      />
                    </span>
                  </TooltipHost>
                  <TooltipHost
                    content={`Cancel`}
                    id={`cancelTempRh`}
                    calloutProps={{ gapSpace: 0 }}
                    styles={{ root: { display: "inline-block" } }}
                  >
                    <span
                      onClick={() =>
                        setState({
                          ...state,
                          isOnEdit: false,
                          tempRhObj: {
                            date: new Date(),
                            temp: 0,
                            rh: 0,
                            sensorId: "",
                          },
                          manageActionsCallout: {
                            isOpen: false,
                            index: undefined,
                            element: undefined,
                            data: undefined,
                          },
                        })
                      }
                    >
                      <Icon
                        path={mdiCloseCircleOutline}
                        size={0.8}
                        className="pointer"
                        color="red"
                      />
                    </span>
                  </TooltipHost>
                </React.Fragment>
              </Stack>
            ) : (
              <span
                onClick={(ele) =>
                  handleCallOutOpenClose(true, ele, index, item)
                }
              >
                <Icon
                  path={mdiDotsVertical}
                  size={0.9}
                  className="pointer"
                  color={BRAND_SECONDARY}
                />
              </span>
            )}
          </>
        );
      case "temp":
        return (
          <React.Fragment>
            {state.isOnEdit && state.manageActionsCallout.index === index ? (
              <TextField
                value={String(state.tempRhObj.temp)}
                type="number"
                name="temp"
                onChange={handleChange}
              // className="width-80"
              />
            ) : (
              <React.Fragment>
                <span
                  className={
                    isTempNotInThreshold(item.temp) ? "text-danger" : ""
                  }
                >
                  {/* {item.temp.toFixed(2)} */}
                  {toFixedValue(item.temp)}
                </span>
                {isTempNotInThreshold(item.temp) && (
                  <Icon
                    path={
                      item.temp < state.slaMatrix.temperature.min
                        ? mdiArrowDown
                        : mdiArrowUp
                    }
                    size={0.5}
                    color="#D62828"
                    style={{ marginBottom: -2 }}
                  />
                )}
              </React.Fragment>
            )}
          </React.Fragment>
        );
      case "rh":
        return (
          <React.Fragment>
            {state.isOnEdit && state.manageActionsCallout.index === index ? (
              <TextField
                value={String(state.tempRhObj.rh)}
                type="number"
                name="rh"
                onChange={handleChange}
              // className="width-80"
              />
            ) : (
              <React.Fragment>
                <span
                  className={
                    item.rh !== "NA" && isRhNotInThreshold(item.rh)
                      ? "text-danger"
                      : ""
                  }
                >
                  {/* {item.rh.toFixed(2)} */}
                  {toFixedValue(item.rh)}
                </span>
                {item.rh !== "NA" && isRhNotInThreshold(item.rh) && (
                  <Icon
                    path={
                      item.rh < state.slaMatrix.humidity.min
                        ? mdiArrowDown
                        : mdiArrowUp
                    }
                    size={0.5}
                    color="#D62828"
                    style={{ marginBottom: -2 }}
                  />
                )}
              </React.Fragment>
            )}
          </React.Fragment>
        );
      case "date":
        return (
          <Text style={{ fontWeight: 600 }}>
            {moment(item.date).format("DD-MMM")}
          </Text>
        );
      default:
        return <span>{column.fieldName ? item[column.fieldName] : ""}</span>;
    }
  };

  const handleChange = (e: any) => {
    setState({
      ...state,
      tempRhObj: {
        ...state.tempRhObj,
        [e.target.name]: e.target.value,
      },
    });
  };

  const onUpdateTempRh = async () => {
    let tempRhObj = { ...state.tempRhObj };
    tempRhObj.temp = Number(tempRhObj.temp);
    tempRhObj.rh = Number(tempRhObj.rh);
    // tempRhObj.date = moment(tempRhObj.date).format("YYYY-MM-DD");

    if (!state.tempRhObj.temp) {
      tempRhObj.temp = 0;
    }
    if (!state.tempRhObj.rh) {
      tempRhObj.rh = 0;
    }
    setState({ ...state, isLoading: true });
    let result = await updateTempAndHumidity(tempRhObj);
    if (result?.success) {
      let tempAndHumidity = [...state.tempHumidity];
      if (state.manageActionsCallout.index !== undefined) {
        tempAndHumidity[state.manageActionsCallout.index].temp =
          state.tempRhObj.temp || 0;
        tempAndHumidity[state.manageActionsCallout.index].rh =
          state.tempRhObj.rh || 0;
      }
      setState({
        ...state,
        tempRhObj: {
          date: new Date(),
          temp: 0,
          rh: 0,
          sensorId: "",
        },
        isOnEdit: false,
        manageActionsCallout: {
          isOpen: false,
          index: undefined,
          element: undefined,
          data: undefined,
        },
        isLoading: false,
      });
      showToast("Ambient Temp & Rh value updated successfully", "success");
    } else {
      setState({ ...state, isLoading: false });
      showToast(result?.message || "Error while updating ambient temp & rh", "error");
    }
  };

  const isTempNotInThreshold = (tempValue: number) => {
    if (!state.slaMatrix.temperature) return false;
    if (
      tempValue < state.slaMatrix.temperature.min ||
      tempValue > state.slaMatrix.temperature.max
    ) {
      return true;
    } else {
      return false;
    }
  };

  const isRhNotInThreshold = (rhValue: number) => {
    if (!state.slaMatrix.humidity) return false;
    if (
      rhValue < state.slaMatrix.humidity.min ||
      rhValue > state.slaMatrix.humidity.max
    ) {
      return true;
    } else {
      return false;
    }
  };

  // const shimmeredDetailsListProps: IListProps = {
  //   renderedWindowsAhead: 0,
  //   renderedWindowsBehind: 0,
  // };

  const onSearch = async () => {
    if (!state.date) {
      showToast("Please select a date before searching", "error");
    }

    getTempHumidity();
  };

  const downloadTempRhReportPdf = async () => {
    let result = await fetch(
      `${API_URL}temp-rh/report?startDate=${moment(state.searchObj.startDate)
        .startOf("month")
        .format("YYYY-MM-DD")}&endDate=${moment(state.searchObj.endDate)
          .endOf("month")
          .format("YYYY-MM-DD")}&datacenterId=${state.searchObj.datacenterId}&isAmbient=${true}`,
      {
        method: "GET",
        credentials: 'include', // Enable credentials for CORS
        headers: {
          at: getToken(),
        },
      }
    );
    let pdf = await result.blob();
    const pdfFile = await new Blob([pdf], { type: "application/pdf" });
    const pdfFileURL = await URL.createObjectURL(pdfFile);
    var a: any = document.createElement("a");
    document.body.appendChild(a);
    a.style = "display:none";
    a.href = pdfFileURL;
    // a.download = `${state.customer.name} Monthly Temp & Humidity Report.pdf`;
    a.download = `${customerName} Ambient Monthly Temp & Humidity Report.pdf`;
    a.click();
  };

  const handleDialogOpen = (isOpen: boolean, index?: number) => {
    let tempHumidity = undefined;
    if (index !== undefined) {
      tempHumidity = { ...state.tempHumidity[index] };
    }
    setState({
      ...state,
      manageTempRhDialog: {
        isOpen,
        index,
        data: tempHumidity,
      },
    });
  };

  const handleDialogClose = () => {
    let obj = {
      ...state,
      manageTempRhDialog: {
        isOpen: false,
        index: undefined,
        data: undefined,
      },
    };
    setState(obj);
    // getTempHumidity(obj);
  };

  const closeCallender = (ev?: any) => {
    setState({
      ...state,
      showCallender: false,
    });
  };

  return (
    <React.Fragment>
      {state.isLoading && <Loading />}
      <Stack tokens={childrenGap} className="pt-16">
        <Stack.Item>
          <Stack
            horizontal
            wrap
            tokens={childrenGap}
            horizontalAlign="space-between"
          >
            <Stack.Item>
              <Stack tokens={childrenGap} horizontal horizontalAlign="start">
                <Stack.Item>
                  <Dropdown
                    placeholder="Select a datacenter"
                    selectedKey={state.searchObj.datacenterId}
                    styles={{ dropdown: { width: 200 } }}
                    options={state.datacenterDropdown}
                    onChange={(e, v: IDropdownOption | undefined) => {
                      if (v) {
                        setState({
                          ...state,
                          searchObj: {
                            ...state.searchObj,
                            datacenterId: v.key as string,
                          },
                        });
                      }
                    }}
                  />
                </Stack.Item>
                <Stack.Item>
                  <div
                    ref={(calendarBtn) =>
                      (calendarButtonElement = calendarBtn!)
                    }
                  >
                    <DefaultButton
                      text={
                        !state.date
                          ? "Select a month"
                          : moment(state.date).format("MMM-YYYY")
                      }
                      onClick={() =>
                        setState({ ...state, showCallender: true })
                      }
                      className="month-picker-btn"
                    />
                  </div>
                  {state.showCallender && (
                    <Callout
                      isBeakVisible={false}
                      gapSpace={0}
                      doNotLayer={false}
                      target={calendarButtonElement}
                      directionalHint={DirectionalHint.bottomLeftEdge}
                      onDismiss={() => closeCallender()}
                      setInitialFocus
                    >
                      <FocusTrapZone
                        firstFocusableSelector="ms-DatePicker-day--today"
                        isClickableOutsideFocusTrap
                      >
                        <Calendar
                          // eslint-disable-next-line react/jsx-no-bind
                          onSelectDate={(date: Date | null | undefined) =>
                            setState({
                              ...state,
                              date: date as any,
                              searchObj: {
                                ...state.searchObj,
                                startDate: moment(date)
                                  .startOf("month")
                                  .toDate(),
                                endDate: moment(date).endOf("month").toDate(),
                              },
                              showCallender: false,
                            })
                          }
                          onDismiss={() => closeCallender()}
                          isMonthPickerVisible={true}
                          value={state.date}
                          firstDayOfWeek={DayOfWeek.Sunday}
                          strings={DayPickerStrings}
                          isDayPickerVisible={false}
                          highlightCurrentMonth={false}
                          highlightSelectedMonth={true}
                          showMonthPickerAsOverlay={false}
                          showGoToToday={false}
                        />
                      </FocusTrapZone>
                    </Callout>
                  )}
                </Stack.Item>
                <Stack.Item>
                  <PrimaryButton text="Search" onClick={() => onSearch()} />
                </Stack.Item>
              </Stack>
            </Stack.Item>
          </Stack>
        </Stack.Item>
        <Stack.Item>
          <Stack horizontal horizontalAlign="space-between" wrap tokens={childrenGap}>
            <Stack.Item>
              <PrimaryButton
                text="Download Report"
                disabled={
                  state.isLoading === true || state.tempHumidity.length === 0 || !state.customerConfig.showAmbientSensors
                }
                onClick={() => downloadTempRhReportPdf()}
              // className="custom-secondary-btn"
              />
            </Stack.Item>
            {![2, 4, 5].includes(tokenData.role) && (
              <Stack.Item>
                <Toggle
                  checked={state.customerConfig.showAmbientSensors}
                  onText="Hide Ambient Sensor"
                  offText="Show Ambient Sensor"
                  onChange={async (e, v) => {
                    let customerConfig = { ...state.customerConfig };
                    customerConfig.showAmbientSensors = v as boolean;
                    setState({ ...state, isLoading: true });
                    const result = await addOrUpdateCustomerConfig(customerConfig);
                    if (result?.success) {
                      setState({
                        ...state,
                        customerConfig: result.data,
                        isLoading: false,
                      });
                    } else {
                      setState({ ...state, isLoading: false });
                      showToast(
                        result.message ||
                        "Error while updating customer config",
                        "error"
                      );
                    }
                  }}
                />
              </Stack.Item>
            )}
          </Stack>
        </Stack.Item>
        {state.customerConfig.showAmbientSensors ? (
          <Stack.Item>
            {state.tempHumidity.length > 0 ? (
              <Fabric>
                <ShimmeredDetailsList
                  items={state.tempHumidity}
                  columns={[
                    {
                      key: "date",
                      name: "Date",
                      fieldName: "date",
                      minWidth: 200,
                      maxWidth: 250,
                      isResizable: true,
                    },
                    {
                      key: "temp",
                      name: "Temperature",
                      fieldName: "temp",
                      minWidth: 200,
                      maxWidth: 250,
                      isResizable: true,
                    },
                    {
                      key: "rh",
                      name: "Humidity",
                      fieldName: "rh",
                      minWidth: 200,
                      maxWidth: 250,
                      isResizable: true,
                    },
                    {
                      key: "actions",
                      name: "Actions",
                      fieldName: "actions",
                      minWidth: 200,
                      maxWidth: 250,
                      isResizable: true,
                    },
                  ]}
                  onRenderItemColumn={_renderItemColumn as any}
                  // onShouldVirtualize={() => false}
                  // enableShimmer={state.isLoading}
                  compact={true}
                  setKey="tempHumidity"
                  layoutMode={DetailsListLayoutMode.justified}
                  selectionMode={SelectionMode.none}
                // listProps={shimmeredDetailsListProps}
                />
              </Fabric>
            ) : (
              <NoDataTile title="No Readings Found for this Customer"></NoDataTile>
            )}
          </Stack.Item>
        ) : (
          <NoDataTile title="Ambient Sensor Readings are not enabled for this Customer"></NoDataTile>
        )}
      </Stack>
      {state.manageActionsCallout.isOpen && (
        <Callout
          styles={{ root: { width: 95, padding: 20 } }}
          role="alertdialog"
          ariaLabelledBy={
            state.manageActionsCallout &&
            state.manageActionsCallout.data?.quadrantId
          }
          gapSpace={0}
          target={state.manageActionsCallout.element}
          directionalHint={DirectionalHint.leftCenter}
          onDismiss={() => handleCallOutOpenClose(false)}
        // setInitialFocus={true}
        >
          <Stack tokens={childrenGap8}>
            <Stack.Item className="pointer">
              <span
                onClick={() => {
                  handleDialogOpen(true, state.manageActionsCallout.index);
                }}
                className="callout-options"
              >
                View
              </span>
            </Stack.Item>
            {![2, 4, 5].includes(tokenData.role) && (
              <Stack.Item className="pointer">
                <span
                  onClick={() => {
                    setState({
                      ...state,
                      tempRhObj: {
                        date: state.manageActionsCallout.data.date,
                        temp: state.manageActionsCallout.data?.temp as number,
                        rh: state.manageActionsCallout.data?.rh as number,
                        sensorId: state.manageActionsCallout.data?.sensorId,
                      },
                      manageActionsCallout: {
                        ...state.manageActionsCallout,
                        isOpen: false,
                      },
                      isOnEdit: true,
                    });
                  }}
                  className="callout-options"
                >
                  Edit
                </span>
              </Stack.Item>
            )}
          </Stack>
        </Callout>
      )}
      {state.manageTempRhDialog.isOpen && (
        <ManageTempAndRhDialog
          handleDialogClose={() => handleDialogClose()}
          data={state.manageTempRhDialog.data}
          slaMatrix={state.slaMatrix}
          date={state.manageTempRhDialog.data.date}
        />
      )}
    </React.Fragment>
  );
};

export default AmbientTempRhMain;
